import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

import { useAIParserSession } from "./use-ai-parser-session"

type Data = {
  sessionId: string
  filenames: string[]
}

function deleteDocuments(data: Data) {
  const { sessionId, filenames } = data

  return api.delete("/parser/delete-documents", {
    data: { session_id: sessionId, filenames },
  })
}

export function useDeleteDocumentsMutation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { currentSessionId } = useAIParserSession()

  return useMutation({
    mutationFn: deleteDocuments,
    onSuccess: async (_, data) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.fullSession(currentSessionId ?? ""),
      })
      toast.success(t("pages.ai_parser.toasts.documents_deleted", { count: data.filenames.length }))
    },
  })
}
